import { useMemo } from "react";

import { getOTCProduct } from "components/Marketing/OTC/OTCHelper";

/*

Comment 2: Market Average Price

Accumulated price is the wtd average price of accumulated swaps. 
For a KO Trade or Suspecnsion trade, the Accumulated Price is just the singular level where the Enchancmnet x2 is…..479 for example. 
There is only one single level where there are sales on.

Where this rule does NOT apply – the Floor/Ceiling trade…… say we have a structure where the Floor is 435 and the Enhancement x2 is 480…….
- Days where market settles above 480 = sell at 480 x2 quantity
- Days where market settles between 435 -480 = sell at 480 x1 quantity
- Days where market settles below 435 = sell at 435 x1
The Accumulated price is the wtd average between bushels sold at 435 and bushels sold at 480

*/

/**
 * Hook for OTC-derived numbers & templates
 * @param {object} otcData  the raw row from API
 * @returns {{
 *   totalAccumulationEvents: number|null,
 *   accumulatedPeriods: number|null,
 *   remainingPeriods: number|null,
 *   perPeriodQty: number|null,
 *   howItWorks: string[]
 * }}
 */
export default function useOTCCalculations(otcData) {
  return useMemo(() => {
    if (!otcData) {
      return {
        totalAccumulationEvents: null,
        accumulatedPeriods: null,
        remainingPeriods: null,
        perPeriodQty: null,
        howItWorks: [],
      };
    }

    const perPeriodQty = otcData.periods_total
      ? Math.abs(otcData?.original_quantity_in_units || 0) / otcData.periods_total
      : null;

    const product = getOTCProduct(otcData);
    const howItWorks = product?.how_it_works_template || [];

    return {
      totalAccumulationEvents: otcData.periods_total,
      accumulatedPeriods: otcData.periods_completed,
      remainingPeriods: otcData.periods_remaining,
      perPeriodQty,
      howItWorks,
    };
  }, [otcData]);
}
